import crypto from "crypto";

export default async (hmacPayload) => {
  const stringifyPayload = JSON.stringify(hmacPayload);

  const generateHmac = crypto
    .createHmac("sha256", "G7aygcpQxOzCwSkW6hueqB9pGgXDGm98")
    .update(stringifyPayload)
    .digest("base64");

  return generateHmac;
};
